import React from "react";
import moment from "moment";
import "moment/locale/th";
import useTranslations from "i18n/useTranslations";
const PointInfo = ({ point = 0, expiredPoint = 0, expiredDate }) => {
  const { t, lang } = useTranslations();
  // หากไม่มี expiredDate ให้ใช้วันที่ปัจจุบัน
  const dateToUse = expiredDate ? expiredDate : moment().toISOString();

  // Format the date and add 543 to the year to convert to Buddhist year
  let formattedDate = "";
  if (lang === "th") {
    formattedDate =
      moment(dateToUse).locale("th").format("DD MMMM ") +
      (parseInt(moment(dateToUse).locale("th").format("YYYY")) + 543);
  } else {
    formattedDate =
      moment(dateToUse).locale("en").format("DD MMMM ") +
      parseInt(moment(dateToUse).locale("en").format("YYYY"));
  }
  return (
    <section id="pPoint">
      <div className="bPoint">
        <div className="bTop">
          <h3 style={{ fontSize: lang === "th" ? 18 : 15 }}>
            <i></i> <span>{t.profile.pointCollection}</span>
          </h3>
          <p>
            <span>
              {Number(point).toLocaleString()
                ? Number(point).toLocaleString()
                : 0}
            </span>{" "}
            {t.profile.points}
          </p>
        </div>
        {expiredDate ? (
          <div className="bBottom">
            <p>
              {Number(expiredPoint).toLocaleString()} {t.profile.expired} {formattedDate}
            </p>
          </div>
        ) : (
          ""
        )}
      </div>
      <div className="bBtn">
        <a
          href="/customer-qr"
          className="btn"
          style={{ textTransform: "none" }}
        >
          <i></i>
          {t.profile.collection}
        </a>
      </div>
    </section>
  );
};

export default PointInfo;
